module.exports = __webpack_public_path__ + "static/img/16.b8c57ea.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content-management/16.jpeg
// module id = MCIE
// module chunks = 3